
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { SlackConfigDialog } from "../SlackConfigDialog";
import { useAuth } from "@/components/AuthProvider";
import { toast } from "sonner";
import { sanitizeInput } from "@/utils/security";

export const NotificationsSection = () => {
  const [showSlackDialog, setShowSlackDialog] = useState(false);
  const { user } = useAuth();
  
  // Ensure user ID is safely sanitized before passing to components
  const safeUserId = user?.id ? sanitizeInput(user.id) : '';

  const handleOpenSlackDialog = () => {
    if (!user?.id) {
      toast.error("You must be logged in to configure notifications");
      return;
    }
    setShowSlackDialog(true);
  };

  return (
    <>
      <Card className="p-4 bg-gray-50 border-gray-100">
        <h3 className="text-sm font-medium text-gray-900 mb-3">Notifications</h3>
        <Button
          variant="outline"
          onClick={handleOpenSlackDialog}
          className="w-full flex items-center justify-center gap-2"
        >
          <img 
            src="/lovable-uploads/4adb0112-98d0-46de-b89c-172f625ba553.png"
            alt="Slack"
            className="w-4 h-4"
          />
          Connect Slack
        </Button>
      </Card>

      {showSlackDialog && (
        <SlackConfigDialog 
          open={showSlackDialog}
          onOpenChange={setShowSlackDialog}
          userId={safeUserId}
        />
      )}
    </>
  );
};
